module.exports = __webpack_public_path__ + "img/EXTERIOR-CIAZ-2.1e0949a1.jpg";